export const colors = ["#FFF6CA", "#EDEDED", "#E5F3FF", "#FFE5E5", "#B2EAB6"];
export const tagsColors = [
    { id: 1, textColor: "#5e9573", backgroundColor: "#e2ede7" },
    { id: 2, textColor: "#d5305d", backgroundColor: "#f3c5d1" },
    { id: 3, textColor: "#9bab1d", backgroundColor: "#f3f7cf" },
    { id: 4, textColor: "#1d56ba", backgroundColor: "#d6e3f9" },
    { id: 5, textColor: "#553dca", backgroundColor: "#e0dcf5" },
    { id: 6, textColor: "#4d6794", backgroundColor: "#ebeff5" },
    { id: 7, textColor: "#875d6a", backgroundColor: "#F2BFCD5E" },
    { id: 8, textColor: "#c1a105", backgroundColor: "#fef5c9" },
];
